import * as React from "react";

import {Box, Container, FormControlLabel, Radio, Typography} from "@mui/material";
import { H2, H4, H5 } from "components/CustomTypography";
import TextFieldComponent from "components/TextField";
import ButtonComponent from "components/Button";
import CheckboxComponent from "components/Checkbox";
import PropTypes from "prop-types";
import {
  schema, getTextfieldData, getButtonData, getCheckboxData, getCheckboxSize,
} from "./helper";
import {useState} from "react";

const SellerProductEntryForm = ({
  setState, product, updateProductSettingClicked, cancelEdit, currency,
}) => {
  const {
    name, id, price, is_popular, is_price_visible, is_active, in_stock, size
  } = product || {};

  const [participants, setParticipants] = useState(size);

  const XS = size.includes("XS");
  const S = size.includes("S");
  const M = size.includes("M");
  const L = size.includes("L");
  const XL = size.includes("XL");
  const XXL = size.includes("XXL");

  const [blur, setblur] = React.useState({
    price: false,
    is_popular: false,
    is_price_visible: false,
    is_active: false,
    in_stock: false,
    size: false,
    XS: false,
    S: false,
    M: false,
    L: false,
    XL: false,
    XXL: false,
  });

  const onFinish = () => {
    updateProductSettingClicked({
      price, is_popular, is_price_visible, is_active, in_stock, size: participants
    }, id);
  };

  const handleTextFieldChange = (event, field) => {
    setState(event.target.value, field);
    setblur({ ...blur, [field]: true });
  };

  const handleCheckBoxChange = (event, field) => {
    setState(event.target.checked, field);
    setblur({ ...blur, [field]: true });
  };

  const handleCheckBoxListChange = (event, field) => {

    setblur({ ...blur, [field]: true });

    const value = field;
    let newlist = participants;

    newlist = newlist.includes(value) ? newlist.filter((f) => f !== value) : [...newlist, value];
    setParticipants(newlist);
    setState(newlist, "size");
  };

  const hasError = () => {
    try {
      return !schema.validateSync(product);
    } catch (err) {
      return true;
    }
  };

  const handleBlur = (field) => {
    setblur({ ...blur, [field]: true });
  };

  const isTouched = () => (blur.price || blur.is_popular || blur.is_price_visible || blur.is_active || blur.in_stock ||
      blur.XS || blur.S || blur.M || blur.L || blur.XL || blur.XXL);

  const getError = (field) => {
    if (blur[field] && hasError()) {
      try {
        schema.validateSyncAt(field, product);
      } catch (err) {
        return err.message;
      }
    }
    return null;
  };

  return (
    <Container>
      <Box>
        <H2>{name}</H2>
        {getTextfieldData(price).map((element) => (
          <Box className="textfield" m={2}>
            <TextFieldComponent
              required
              label={element.label + " (" + currency + ")"}
              value={element.value}
              error={!!getError(element.onChangeField)}
              helperText={getError(element.onChangeField)}
              onChange={(event) => handleTextFieldChange(event, element.onChangeField)}
            />
          </Box>
        ))}

        {getCheckboxData(is_popular, is_price_visible, is_active, in_stock).map((element) => (
          <Box className="textfield" m={2}>
            <CheckboxComponent
              required
              label={element.label}
              value={element.value}
              onChange={(event) => handleCheckBoxChange(event, element.onChangeField)}
            />
          </Box>
        ))}

        {/*
        <H4>Size available:</H4>
        <H5>(Do not select for 1 size items)</H5>
        <Box display="flex" flexWrap="wrap">
        {getCheckboxSize(XS, S, M, L, XL, XXL).map((element) => (
            <Box m={2}>
              <CheckboxComponent
                  required
                  label={element.label}
                  value={element.value}
                  onChange={(event) => handleCheckBoxListChange(event, element.onChangeField)}
              />
            </Box>
        ))}
        </Box>
        */}
      </Box>
      <Typography align="center">
        {getButtonData(onFinish, cancelEdit, hasError, isTouched).map((element) => (
          <ButtonComponent
            sx={{
              m: 2,
            }}
            type={element.type}
            variant={element.variant}
            onClick={element.onClick}
            disabled={element.disabled}
            name={element.name}
          />
        ))}
      </Typography>
    </Container>
  );
};

SellerProductEntryForm.defaultProps = {

};

SellerProductEntryForm.propTypes = {
  currency: PropTypes.string,
  setState: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
  updateProductSettingClicked: PropTypes.func.isRequired,
  cancelEdit: PropTypes.func.isRequired,
};

export default SellerProductEntryForm;
